import { Filmomtale, Genre } from '@filmweb/sanity-types';
import classNames from "classnames";
import styles from "./ShortFacts.module.css";

//#region [Props]
type ShortFactsProps = {
    filmomtale?: Filmomtale | null;
    className?: string;
};
//#endregion

//#region [Component]
export default function ShortFacts({ filmomtale, className }: ShortFactsProps) {
    if (!filmomtale) {
        return null;
    }
    return <div className={classNames(styles.ShortFacts, className)}>
        {(filmomtale.genres?.length ?? 0) > 0 && <span>
            {filmomtale.genres?.map(genre => (genre as Genre).name).join(" / ")}
        </span>}

        {filmomtale.runningTime && <span>{filmomtale.runningTime}</span>}

        {filmomtale.ageRating?.age && <span>{filmomtale.ageRating.age}</span>}

    </div>;
}
//#endregion